"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBCard;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _SVBLabels = require("../../SVBLabels");
var _SVBButton = require("../../SVBButton");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * SVBCard Component
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders SVBCard
 */

/**
 * @param {string} [cardIcon = "icon1.svg"] - icon filename
 * @param {string} [iconLabel = "Article"] - Label displayed for icon
 * @param {string} [link="/apis/authenticate"] - link to the resource
 * @param {string} [buttonLabel="Learn More"]
 * @param {string} [title = "Authentication"] - card title
 * @param {string} [description = "APIs to complete authorization and generate access tokens"] - card body description
 * @param {object} [cardOptions] - controls feature for card
 * cardOptions = {
 cardBootstrapImage (boolean) - will apply bootstrap img class to fit card header full width
 cardClickable (boolean) - whole card is clickable and learn more link is not visible
 titleSeparator (boolean) - adds border separator below cards title used for APIs cards
 externalLink (boolean) - applies property for external link
 cardTypes(string) - "search" applies Global search type cards
 * }
 * @param {object} [categories] - controls tags styles ans positions
 * categories= { - controls category positions and tags lables
    tagsPosition: "footer",
      extraClasses: 'me-2',
      tags:[
        {
          label : "Use",
          type : "use-case"
        },
        {
          label : "FAQ",
          type : "faq"
        }
      ]
    }
 * @param {string} [apiVersionLabel] - Displays verions alongside API NAme but requires cardTypes "search" present in cardOptions
 * @param {string} [extraClasses = "card-extra-class"] 
 * @param {function} [onClick => ()] -additional click prop to whole card
 * Summary
 * This component renders SVBCard
 */
function SVBCard(props) {
  const {
    cardIcon,
    iconLabel,
    link,
    buttonLabel,
    title,
    description,
    cardOptions,
    categories,
    apiVersionLabel,
    extraClasses,
    onClick,
    datatestid,
    explicitImgWidth,
    explicitImgHeight,
    lazyLoading,
    titleStyle,
    descriptionStyle,
    showButton = false,
    handleButtonPress,
    buttonStyle,
    cardBodyStyle
  } = props;
  let ImagePath;
  try {
    ImagePath = cardIcon && require("@svb/svbbranding/dist/assets/icons/".concat(cardIcon));
  } catch (e) {
    console.log("Error: Cannot find icon ".concat(cardIcon));
    //fallback empty icon
    ImagePath = "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";
  }
  const finalClass = extraClasses ? "h-100 " + extraClasses : "h-100";
  const btnLink = link ? link : "#";
  const btnText = buttonLabel ? buttonLabel : "Learn More";
  const tagsPosition = categories && categories.tagsPosition ? categories.tagsPosition : "header";
  const titleTextStyle = titleStyle ? titleStyle : "";
  const descriptionTextStyle = descriptionStyle ? descriptionStyle : "";
  const buttonTextStyle = buttonStyle ? buttonStyle : "";
  const cardItemBodyStyle = cardBodyStyle !== null && cardBodyStyle !== void 0 ? cardBodyStyle : "";
  //element layout for normal cards
  const CardElement = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "card " + finalClass,
    "data-testid": datatestid === null || datatestid === void 0 ? void 0 : datatestid.card,
    onClick: onClick
  }, (cardIcon || iconLabel || categories && tagsPosition === "header") && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-header w-100"
  }, cardOptions && cardOptions.cardBootstrapImage ? ImagePath && /*#__PURE__*/_react.default.createElement("img", {
    src: ImagePath,
    className: "card-img-top mh-100",
    alt: "card-image",
    width: explicitImgWidth ? explicitImgWidth : "350",
    height: explicitImgHeight ? explicitImgHeight : "150",
    loading: lazyLoading ? "lazy" : "eager"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ImagePath && /*#__PURE__*/_react.default.createElement("i", null, /*#__PURE__*/_react.default.createElement("img", {
    src: ImagePath,
    alt: "card-icon",
    width: explicitImgWidth ? explicitImgWidth : "40",
    height: explicitImgHeight ? explicitImgHeight : "40",
    loading: lazyLoading ? "lazy" : "eager"
  })), iconLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "cardicon-label"
  }, iconLabel)), categories && tagsPosition === "header" && /*#__PURE__*/_react.default.createElement("div", {
    className: "float-end"
  }, categories.tags && categories.tags.map((tag, i) => {
    return /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
      extraClasses: categories.extraClasses ? categories.extraClasses : "ms-2",
      key: i,
      labelType: tag.labelType ? tag.labelType : "categories-labels",
      categoryType: tag.type ? tag.type : "faq",
      labelText: tag.label ? tag.label : "text"
    });
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body " + cardItemBodyStyle
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "heading-medium " + titleTextStyle
  }, title, " "), cardOptions && cardOptions.titleSeparator && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-title-separator"
  }), descriptionTextStyle !== "" ? /*#__PURE__*/_react.default.createElement("p", {
    className: "sub-heading fw-normal " + descriptionTextStyle
  }, description) : description && description), (cardOptions && !cardOptions.cardClickable && link || categories && tagsPosition === "footer") && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer w-100",
    "data-testid": datatestid === null || datatestid === void 0 ? void 0 : datatestid.learnMore
  }, link && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: btnLink,
    target: cardOptions && cardOptions.externalLink ? "_blank" : null
  }, btnText), categories && tagsPosition === "footer" && /*#__PURE__*/_react.default.createElement("div", {
    className: "float-start"
  }, categories.tags && categories.tags.map((tag, i) => {
    return /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
      extraClasses: categories.extraClasses ? categories.extraClasses : "me-2",
      key: i,
      labelType: tag.labelType ? tag.labelType : "categories-labels",
      categoryType: tag.type ? tag.type : "faq",
      labelText: tag.label ? tag.label : "text"
    });
  }))), showButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer card-alternative-container"
  }, /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    extraClasses: "svb-button_secondary_no_arrow border-0 rounded px-7 py-2 svb-button_secondary_no_arrow " + buttonTextStyle,
    text: buttonLabel,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    onClick: handleButtonPress
  })));
  //element layout for search cards
  const CardElementSearch = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "card search-type " + finalClass,
    "data-testid": datatestid === null || datatestid === void 0 ? void 0 : datatestid.card,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-header w-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-inline-flex gap-3"
  }, cardOptions && cardOptions.cardBootstrapImage ? ImagePath && /*#__PURE__*/_react.default.createElement("img", {
    src: ImagePath,
    className: "card-img-top mh-100",
    alt: "card-image",
    width: explicitImgWidth ? explicitImgWidth : "350",
    height: explicitImgHeight ? explicitImgHeight : "150",
    loading: lazyLoading ? "lazy" : "eager"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ImagePath && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("i", null, /*#__PURE__*/_react.default.createElement("img", {
    src: ImagePath,
    alt: "card-icon",
    width: explicitImgWidth ? explicitImgWidth : "32",
    height: explicitImgHeight ? explicitImgHeight : "32",
    loading: lazyLoading ? "lazy" : "eager"
  }))), iconLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "cardicon-label"
  }, iconLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-inline-flex gap-3 pe-10"
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "heading-medium text-break " + titleTextStyle
  }, title), apiVersionLabel && /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
    extraClasses: "my-1",
    labelType: "categories-labels",
    labelText: apiVersionLabel,
    categoryType: "version"
  })), categories && tagsPosition === "header" && /*#__PURE__*/_react.default.createElement("div", {
    className: "float-end"
  }, categories.tags && categories.tags.map((tag, i) => {
    return /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
      extraClasses: categories.extraClasses ? categories.extraClasses : "ms-2",
      key: i,
      labelType: tag.labelType ? tag.labelType : "categories-labels",
      categoryType: tag.type ? tag.type : "faq",
      labelText: tag.label ? tag.label : "text"
    });
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body " + cardItemBodyStyle
  }, descriptionTextStyle !== "" ? /*#__PURE__*/_react.default.createElement("p", {
    className: "sub-heading fw-normal " + descriptionTextStyle
  }, description) : description && description), (cardOptions && !cardOptions.cardClickable && link || categories && tagsPosition === "footer") && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer w-100",
    "data-testid": datatestid === null || datatestid === void 0 ? void 0 : datatestid.learnMore
  }, link && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: btnLink,
    target: cardOptions && cardOptions.externalLink ? "_blank" : null
  }, btnText), categories && tagsPosition === "footer" && /*#__PURE__*/_react.default.createElement("div", {
    className: "float-start"
  }, categories.tags && categories.tags.map((tag, i) => {
    return /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
      extraClasses: categories.extraClasses ? categories.extraClasses : "me-2",
      key: i,
      labelType: tag.labelType ? tag.labelType : "categories-labels",
      categoryType: tag.type ? tag.type : "faq",
      labelText: tag.label ? tag.label : "text"
    });
  }))), showButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer card-alternative-container"
  }, /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    extraClasses: "svb-button_secondary_no_arrow border-0 rounded px-7 py-2 svb-button_secondary_no_arrow " + buttonTextStyle,
    text: buttonLabel,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    onClick: handleButtonPress
  })));
  const CardElementWithLink = props => {
    const {
      cardTypes,
      buttonLink,
      externalLink
    } = props;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: buttonLink,
      target: externalLink ? "_blank" : null
    }, cardTypes === "search" ? /*#__PURE__*/_react.default.createElement(CardElementSearch, null) : /*#__PURE__*/_react.default.createElement(CardElement, null));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cardOptions ? cardOptions.cardTypes === "search" ? cardOptions.cardClickable ? /*#__PURE__*/_react.default.createElement(CardElementWithLink, {
    cardTypes: cardOptions.cardTypes,
    buttonLink: btnLink,
    externalLink: cardOptions.externalLink
  }) : /*#__PURE__*/_react.default.createElement(CardElementSearch, null) : cardOptions.cardClickable ? /*#__PURE__*/_react.default.createElement(CardElementWithLink, {
    cardTypes: cardOptions.cardTypes,
    buttonLink: btnLink,
    externalLink: cardOptions.externalLink
  }) : /*#__PURE__*/_react.default.createElement(CardElement, null) : /*#__PURE__*/_react.default.createElement(CardElement, null));
}